import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { authHeader } from '../../../../services/authHeader';
import { setUser } from '../../../../store/userSlice';
import BackButton from '../../../Shared/BackButton';
import FormFeedback from '../../../Shared/FormFeedback';
import styles from './ChangeEmail.module.css';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ChangeEmail = () => {
    const [email, setEmail] = useState('');
    const [touched, setTouched] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const user = useSelector((state) => state.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isInvalid = touched && email.length > 0 && !emailRegex.test(email.trim());

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccessMessage(null);

        const normalizedEmail = email.trim().toLowerCase();
        if (!emailRegex.test(normalizedEmail)) {
            setError('Please enter a valid email address.');
            return;
        }

        try {
            await axios.patch(`${process.env.REACT_APP_API_URL}/api/c/changeemail/`, {
                new_email: normalizedEmail,
            }, authHeader());

            setSuccessMessage('Successfully updated email!');
            setEmail('');
            dispatch(setUser({ ...user, email: normalizedEmail }));
            navigate(-1);
        } catch (err) {
            const errorMessage = err.response?.data?.message || 'An unexpected error occurred.';
            setError(errorMessage);
        }
    };

    return (
        <div className={styles.container}>
            <BackButton />
            <h1 className={styles.title}>Change Email</h1>
            <form className={styles.form} onSubmit={handleSubmit}>
                <label className={styles.label}>
                    New Email
                    <input
                        className={styles.input}
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onBlur={() => setTouched(true)}
                        placeholder="Enter new email"
                        required
                    />
                    {isInvalid && (
                        <span className={styles.errorMessage}>Please enter a valid email address.</span>
                    )}
                </label>
                <button className={styles.submitButton} type="submit">Update Email</button>
            </form>
            <FormFeedback error={error} success={successMessage} />
        </div>
    );
};

export default ChangeEmail;
